import {useSyncExternalStore} from 'react';
import {DEFAULT_RULE_SYSTEM, getSelectedRules, setSelectedRules, subscribeToRules} from '../utils/rulesSystem';

export function useRulesSystem() {
  const selectedRules = useSyncExternalStore(subscribeToRules, getSelectedRules, () => DEFAULT_RULE_SYSTEM);
  return {selectedRules, setSelectedRules};
}
